import type { PsHttpError } from '@patsnap/tahiti-core';

/**
 * 使用量超限处理(ErrorCode 33100007)
 */
export interface UsageLimitHandler {
    handle(error: PsHttpError): void;
}

export const UsageLimitHandler = Symbol('UsageLimitHandler');
